module.exports = __webpack_public_path__ + "static/media/MHRM13N0001.21c77775.svg";